export default __webpack_public_path__ + "error-icon.fde1368982e51742b4920fdb9ea9864b.svg";